import { css, styled } from "goober";

// Mirrors the composer’s attachment chip.
export const chatPillClassName = css`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 200px;
  height: 20px;
  padding: 0 8px 0 6px;
  border-radius: 38px;
  background: var(--alpha4);
  color: var(--text-secondary);
  font-size: 10px;
  font-weight: 450;
  line-height: 12px;
  letter-spacing: 0;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  &:hover,
  &[aria-current="true"],
  &[aria-expanded="true"] {
    background: var(--alpha8);
  }
`;

export const inlineChatPillClassName = css`
  vertical-align: text-bottom;
  /* Negative margins keep the line-box footprint at 16px so lines don’t spread; the doubled class outranks MarkdownStyles’ margin reset. */
  && {
    margin: -2px 2px;
  }
`;

export const ChatPillLabel = styled("span")`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;
